import type { Culte } from '@/types/Culte'

export default function HoraireCard({ jour, label, creneaux, note }: Culte) {
  return (
    <div className="flex flex-col gap-3 p-5 md:flex-row md:items-center md:gap-4 hover:bg-cmp-sky-light/30 transition-colors">
      {/* Sur mobile : badge + libellé forment une première ligne, les horaires suivent en dessous
          sous forme de badges (plus grands, plus lisibles au pouce). Sur desktop (md+) : ligne unique, inchangée. */}
      <div className="flex items-center gap-3 md:flex-1 md:min-w-0">
        <div className="w-14 h-14 rounded-2xl bg-cmp-navy flex items-center justify-center shrink-0 shadow-sm shadow-cmp-navy/25">
          <span className="text-white font-bold text-xs uppercase tracking-wide">{jour.slice(0, 3)}</span>
        </div>

        <div className="min-w-0">
          <p className="font-semibold text-cmp-navy text-sm">{label}</p>
          <p className="text-xs text-gray-400 mt-0.5">{note ?? jour}</p>
        </div>
      </div>

      <div className="flex flex-wrap gap-2 md:flex-col md:items-end md:gap-1 md:shrink-0">
        {creneaux.map((c) => (
          <span
            key={c.heureDebut}
            className="text-sm font-bold text-cmp-blue bg-cmp-sky-light rounded-full px-3 py-1.5 tabular-nums whitespace-nowrap md:bg-transparent md:text-cmp-navy md:px-0 md:py-0"
          >
            {c.heureDebut} – {c.heureFin}
          </span>
        ))}
      </div>
    </div>
  )
}
